import React from 'react'
import PropTypes from 'prop-types'

class ListLoader extends React.Component {
  constructor() {
    super()
    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    return this.props.onShowMore(this.props.currentPage+1)
  }

  isLastPage(page) {
    return page === this.props.totalPages
  }

  render() {
    if (this.props.totalPages == 0) {
      return null
    }

    return (
      !this.isLastPage(this.props.currentPage)
        && (
        <button className={this.props.buttonClass} onClick={this.onClick}>
          {this.props.text}
        </button>
        )
    )
  }
}

ListLoader.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onShowMore: PropTypes.func.isRequired,
  buttonClass: PropTypes.string,
  text: PropTypes.string,
}

ListLoader.defaultProps = {
  currentPage: 0,
  totalPages: 0,
  buttonClass: 'btn btn-transparent',
  text: 'show more',
}

export default ListLoader
